import React from 'react';
import i18n from './Localization';
import Layout from './Layout';

function Clue(props) {
  var clue = props.value;
  var contents = clue.get('number') + ". " + clue.get('clue');
  var extraClass = "";

  if (clue.get('active'))
    extraClass = " xwordjs-clue-active";
  else if (clue.get('crossActive'))
    extraClass = " xwordjs-clue-cross-active";

  let fontSize = Math.round((15 / Layout.gridHeight) * 1.5 + 12.5);

  return (
    <div 
      className={"xwordjs-clue" + extraClass} 
      id={"clue_" + clue.get('index')} 
      style={{ fontSize }}
      onClick={() => props.onClick(clue)} 
      onTouchEnd={(e) => {props.onClick(clue); e.preventDefault();}}
      dangerouslySetInnerHTML={{ __html: contents }}
    />
  );
}

function Clues(props) {
  var across = [];
  var down = [];
  for (var i=0; i < props.value.length; i++) {
    var clue = props.value[i];

    if (clue.get('direction') === 'A') {
      across.push(props.value[i]);
    } else {
      down.push(props.value[i]);
    }
  }
  return(
    <div id="xwordjs-cluelist-container" className="xwordjs-cluelist-container">
      <Cluelist selectClue={props.selectClue} value={across} title={i18n.t("cluesAcross")}/>
      <Cluelist selectClue={props.selectClue} value={down} title={i18n.t("cluesDown")}/>
    </div>
  );
}

function Cluelist(props) {
  var list = [];
  for (var i=0; i < props.value.length; i++) {
    var clue = props.value[i];
    list.push(<Clue key={"clue_" + i} onClick={(x) => props.selectClue(x)} value={clue}/>);
  }
  return (
    <div onTouchEnd={(e) => e.preventDefault()}>
    <h3>{props.title}</h3>
    <div className="xwordjs-cluelist">
    {list}
    </div>
    </div>
  );
}

export default Clues;
